<div class="full-width-div">
    <video id="videoplayer" autoplay style="width:100%" #videoplayer controls>
          <source src="{{videofile}}" type="video/mp4">
    </video>
</div>